import {HttpService} from "../http/HttpService";
import {AbstractAdminEntityService} from "./AbstractAdminEntityService";
import {CasinoGame, ListCasinoGameResponse} from "../http/protocol";


export class CasinoGameService  extends AbstractAdminEntityService<CasinoGame, ListCasinoGameResponse>  {

    constructor(http : HttpService) {
        super("/casino-game", http)
    }

    getGameByGameOrder(gameOrder : number) : Promise<CasinoGame> {
        return this.http.get(this.entityPath+"/order/" + gameOrder);
    }
}